/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMS41IDEyVjJIMi4zNTQ2OFYxMkgxLjVaTTQuNjg4NzYgMTJMMTIuNSA3TDQuNjg4NzYgMlYxMlpNNS41NDM0NCAxMC4zMzMzVjMuNjY2NjdMMTAuODM5OCA3TDUuNTQzNDQgMTAuMzMzM1oiIGZpbGw9ImJsYWNrIi8+PC9zdmc+";